/**
 * Created by Andrey Popov on 01.09.20
 */

const MouseCardView = CardView.extend({
    ctor: function (card) {
        this._super(card, {
            animation_json: bundles.card.jsons.mouse_json
        });

        this.card.on("afterFeed", this.createListener(this.afterFeed.bind(this)));
    },

    afterFeed: function () {
        this.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
        this.animation.setAnimation(0, "bounce", false);
        this.animation.setCompleteListener(() => {
            this.animation.setCompleteListener();
            this.runAction(new cc.RemoveSelf());
        });
    },

    setIdleAnimation: function () {
        this.animation.setAnimation(1, this.card.isOpen() ? "mouse_idle" : "idle_close", true);
    }
});